"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var comboboxHelperUtils_exports = {};
__export(comboboxHelperUtils_exports, {
  computedId: () => computedId,
  defineScrollBehavior: () => defineScrollBehavior,
  filterComboboxItems: () => filterComboboxItems,
  getOptionValue: () => getOptionValue,
  truncateTextWithEllipsis: () => truncateTextWithEllipsis
});
module.exports = __toCommonJS(comboboxHelperUtils_exports);
var import_truncate = __toESM(require("lodash/truncate"));
var filterComboboxItems = function filterComboboxItems2(selected, value) {
  return selected.filter(function(item) {
    return item !== value;
  });
};
var computedId = function computedId2(nodeName, id) {
  return "select-".concat(nodeName).concat(id ? "-".concat(id) : "");
};
var isScrollable = function isScrollable2(listBox) {
  return listBox && listBox.clientHeight < listBox.scrollHeight;
};
var maintainScrollVisibility = function maintainScrollVisibility2(activeOption, listBox) {
  var offsetHeight = activeOption.offsetHeight, offsetTop = activeOption.offsetTop;
  var parentOffsetHeight = listBox.offsetHeight, scrollTop = listBox.scrollTop;
  var isAbove = offsetTop < scrollTop;
  var isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
  if (isAbove) {
    listBox.scrollTo(0, offsetTop);
  } else if (isBelow) {
    listBox.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
  }
};
var isElementInView = function isElementInView2(activeOption) {
  var bounding = activeOption.getBoundingClientRect();
  return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var defineScrollBehavior = function defineScrollBehavior2(listBox, options, position) {
  if (isScrollable(listBox)) {
    maintainScrollVisibility(options[position], listBox);
  }
  if (!isElementInView(options[position])) {
    options[position].scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  }
};
var truncateTextWithEllipsis = function truncateTextWithEllipsis2(text, maxCharLength) {
  return (0, import_truncate.default)(text, {
    length: maxCharLength
  });
};
var getOptionValue = function getOptionValue2(children, maxVisibleChars) {
  if (maxVisibleChars && typeof children === "string") {
    if (maxVisibleChars <= 3) {
      return truncateTextWithEllipsis(children, 10);
    }
    return truncateTextWithEllipsis(children, maxVisibleChars);
  }
  return children;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  computedId,
  defineScrollBehavior,
  filterComboboxItems,
  getOptionValue,
  truncateTextWithEllipsis
});
//# sourceMappingURL=comboboxHelperUtils.js.map